import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Activity } from './activity';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { ParameterValue } from '../base/parameter-value';
import { LinkedService } from '../linkedservice/linkedservice';
import { DataQualityLinkedService } from '../linkedservice/data-quality.linkedservice';
@Metamodel.model({
    name: ModelConstants.invokeDataQuality,
    referable: true
})
export class InvokeDataQualityActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly DATAQUALITYID: IAttribute;
    public static readonly WORKSPACEID: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        reference: true,
        type: DataQualityLinkedService.MODEL,
        constraint: {
            validator: InvokeDataQualityActivity.validateConnection
        }
    })
    public dataQualityLinkedService: DataQualityLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    @Metamodel.attribute({
        display: shellStringResources.DataQualityIdLabel,
        association: 'DATAQUALITYID',
        constraint: {
            validator: InvokeDataQualityActivity.validateDataQuality
        },
        templatable: true
    })
    public dataQualityId: string;

    @Metamodel.attribute({
        display: shellStringResources.TridentWorkspaceLabel,
        association: 'WORKSPACEID',
        constraint: {
            validator: InvokeDataQualityActivity.validateWorkspace
        },
        templatable: true
    })
    public workspaceId: string;

    private static validateDataQuality(_invokeDataQualityActivity?: InvokeDataQualityActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.DataQualityLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateWorkspace(_invokeDataQualityActivity?: InvokeDataQualityActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.TridentWorkspaceLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateConnection(_invokeDataQualityActivity?: InvokeDataQualityActivity, linkedService?: LinkedService): IViolation[] | undefined {
        if (!linkedService) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.ConnectionLabel)
                }
            ];
        } else if (linkedService && linkedService.getLinkedServiceType() != Metamodel.modelFor(DataQualityLinkedService).name) {
            return [
                {
                    message: () =>
                        format(
                            shellStringResources.ActivityNotSupportLinkedServiceError,
                            format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.DataQualityLabel),
                            format(shellStringResources.ModelName_ConnectionTemplate, Metamodel.modelOf(linkedService).name)
                        ),
                    messageType: 'unsupported'
                }
            ];
        }
        return undefined;
    }
}
